import { FC, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { logSignIn } from "../../services/logging";
import {
  consumePendingJoin,
  getDecodedToken,
  isLoggedIn,
  joinAccount,
  setAuthToken,
} from "../../features/accounts/auth.service";
import LoadingScreen from "../../components/LoadingScreen";
import { Button } from "@mui/material";
import { AttributionService } from "../../services/attribution.service";

const ExternaLogin: FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const error = searchParams.get("error");

  let errorMessage = error ? "Sign in Errror" : null;
  switch (error) {
    case "externalsigninerror":
      errorMessage = "External sign in error";
      break;
    case "notregistered":
      errorMessage = "User is not registered.";
      break;
    case "access_denied":
      errorMessage = "Access denied.";
      break;
    case "auth_failed":
      errorMessage = "Sign in failed. Please try again.";
      break;
  }

  useEffect(() => {
    // Store attribution parameters from URL if they exist
    if (searchParams.size > 0) {
      AttributionService.storeFromCurrentUrl(searchParams);
    }

    if (error === "expired") {
      navigate("/login");
      return;
    }
    if (error) return;

    const token = searchParams.get("token");

    if (token) {
      setAuthToken(token);
      if (isLoggedIn()) {
        logSignIn(getDecodedToken()?.provider);
        const returnUrl = searchParams.get("path") ?? "/";
        // Existing-account invitee who signed in via SSO from the /join flow:
        // complete the workspace join now that we're authenticated, then
        // hard-reload so the session picks up the new account. The invite is
        // carried by sessionStorage (robust across the OAuth round-trip), with
        // the server-threaded ic/je query params as a fallback.
        const pending = consumePendingJoin();
        const code = pending?.code ?? searchParams.get("ic");
        const email = pending?.email ?? searchParams.get("je");
        if (code && email) {
          joinAccount(email, code)
            .catch(() => {
              /* logged in regardless */
            })
            .finally(() => {
              window.location.href = returnUrl;
            });
        } else {
          window.location.href = returnUrl;
        }
        return;
      }
    }
    navigate("/login");
  }, [error, navigate, searchParams]);

  return (
    <>
      {!error && <LoadingScreen title="signing in..." fullScreen />}
      {error && (
        <>
          <h1>{errorMessage}</h1>
          <Button variant="outlined" href="/login" sx={{ mt: 2 }}>
            Back to sign in
          </Button>
        </>
      )}
    </>
  );
};

export default ExternaLogin;
